// 文件编码: UTF-8
// 说明：本文件包含中文注释，需确保以 UTF-8 编码保存
import { request } from '@umijs/max';

export interface SmtpSettings {
	smtp_enable?: number;
	smtp_server?: string;
	smtp_port?: number;
	smtp_username?: string;
	smtp_password?: string;
	smtp_from_email?: string;
	smtp_from_name?: string;
	smtp_ssl?: number;
	smtp_to_email?: string;
}

export interface ApiResponse<T = any> {
	success: boolean;
	message?: string;
	data?: T;
}

// SMTP设置相关接口
export async function getSmtpSettings(): Promise<ApiResponse<Record<string, any>>> {
	return request('/api/settings/smtp', {
		method: 'GET'
	});
}

export async function updateSmtpSettings(data: SmtpSettings): Promise<ApiResponse> {
	return request('/api/settings/smtp', {
		method: 'POST',
		data
	});
}

// 发送测试邮件（SMTP连接测试）
export async function testSmtpConnection(data: { email: string }): Promise<ApiResponse> {
	return request('/api/settings/smtp/test', {
		method: 'POST',
		data
	});
}

// 网站信息设置相关接口
export async function getWebsiteInfo(language?: string): Promise<ApiResponse<Record<string, any>>> {
	return request('/api/settings/site', {
		method: 'GET',
		params: language ? { language } : {}
	});
}

export async function updateWebsiteInfo(data: any): Promise<ApiResponse> {
	return request('/api/settings/site', {
		method: 'POST',
		data
	});
}

export async function uploadLogo(data: FormData): Promise<ApiResponse> {
	return request('/api/settings/upload-logo', {
		method: 'POST',
		data,
		requestType: 'form'
	});
}

// 获取所有设置
export async function getAllSettings(): Promise<ApiResponse<Record<string, any>>> {
	return request('/api/settings', {
		method: 'GET'
	});
}

// 更新设置
export async function updateSettings(data: Record<string, any>): Promise<ApiResponse> {
	return request('/api/settings', {
		method: 'POST',
		data
	});
}

// 获取特定组的设置
export async function getSettingsByGroup(group: string): Promise<ApiResponse<Record<string, any>>> {
	return request(`/api/settings/group/${group}`, {
		method: 'GET'
	});
}

// 获取语言列表
export async function getLanguages(): Promise<ApiResponse<{ default: string; languages: any[] }>> {
	return request('/api/settings/languages', {
		method: 'GET'
	});
}

// 更新特定组的设置
export async function updateSettingsByGroup(
	group: string,
	data: Record<string, any>
): Promise<ApiResponse> {
	return request(`/api/settings/group/${group}`, {
		method: 'POST',
		data
	});
}
